import { useEffect } from "react";
import socket from './../socket/socket'

const useSocket = (eventName, eventHandler) => {

  useEffect(() => {

    const socketInstance = socket();

    // if socket failed
    if (!socketInstance) return;

    socketInstance?.on(eventName, eventHandler);

    return () => {
      socketInstance?.off(eventName, eventHandler);
    }

  }, [eventName, eventHandler]);

  return socket();

}

export default useSocket;